import { useState } from 'react';

import { Tooltip } from '@cobliteam/ui/components';

import Icon from '@cobliteam/ui/icons';

function TailwindIndicator() {
  const [isOpen, setIsOpen] = useState(true);
  if (!isOpen) return null;

  return (
    <Tooltip content='Breakpoints - ao alterar o tamanho da tela vou te mostrar em qual breakpoint você está!' asChild>
      <div className='group relative flex h-8 w-fit items-center justify-center rounded-lg border border-gray-6 bg-white p-0.5 px-2 font-medium font-mono text-black text-xs shadow-lg'>
        <button type='button' onClick={() => setIsOpen(!isOpen)} className='-top-0.5 -right-1.5 absolute z-50 hidden cursor-pointer rounded-full bg-white p-0.5 group-hover:block'>
          <Icon name='x' size='xs' />
        </button>

        <div className='block mobile:hidden '>{'< mobile'}</div>
        <div className='mobile:flex hidden tablet:hidden flex-row items-center gap-1'>
          <Icon name='smartphone' size='xs' /> mobile
        </div>
        <div className='tablet:flex hidden laptop:hidden flex-row items-center gap-1'>
          <Icon name='tablet-smartphone' size='xs' /> tablet
        </div>
        <div className='laptop:flex desktop:hidden hidden flex-row items-center gap-1'>
          <Icon name='laptop' size='xs' /> laptop
        </div>
        <div className='desktop:flex hidden widescreen:hidden flex-row items-center gap-1'>
          <Icon name='monitor' size='xs' /> desktop
        </div>
        <div className='widescreen:flex hidden flex-row items-center gap-1'>
          <Icon name='tv-minimal' size='xs' /> widescreen
        </div>
      </div>
    </Tooltip>
  );
}

export default TailwindIndicator;
